import { ComponentContentTypes } from '../../../lib/types/content-types'
import { FaqSectionForTabs } from '../../section/faq'
import { SectionGroupForTabs } from '../../section/group'
import { MultiColumnSectionForTabs } from '../../section/multi-column'
import { SingleColumnSectionForTabs } from '../../section/single-column'
import { TestimonialSectionForTabs } from '../../section/testimonial'
import { TwoColumnSectionForTabs } from '../../section/two-column'
import { buildContentRenderer } from '../generic'
import { LinkableBoxesSectionForTabs } from '../../section/linkable-boxes'

const contentTypeMap = {
  [ComponentContentTypes.SectionGroup]: SectionGroupForTabs,
  [ComponentContentTypes.SectionFaq]: FaqSectionForTabs,
  [ComponentContentTypes.SectionMultiColumn]: MultiColumnSectionForTabs,
  [ComponentContentTypes.SectionSingleColumn]: SingleColumnSectionForTabs,
  [ComponentContentTypes.SectionTestimonials]: TestimonialSectionForTabs,
  [ComponentContentTypes.SectionTwoColumns]: TwoColumnSectionForTabs,
  [ComponentContentTypes.SectionLinkableBoxes]: LinkableBoxesSectionForTabs,
} as const

export const TabContentRenderer = buildContentRenderer(contentTypeMap)
